import { Component, type FC, type ReactNode, useEffect } from 'react';

import { RouterProvider } from 'react-router-dom';

import { router } from '@app/router';
import { tokens } from '@shared/styles/tokens';

import { replayEarlyClick } from './app/lib/replayEarlyClick';
import { useRouteMetadata } from './app/seo/RouteMetadata';

class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            padding: tokens.space[48],
            fontFamily: 'monospace',
            color: 'red',
            whiteSpace: 'pre-wrap',
          }}
        >
          <b>RENDER ERROR:</b>
          {'\n'}
          {(this.state.error as Error).message}
          {'\n\n'}
          {(this.state.error as Error).stack}
        </div>
      );
    }
    return this.props.children;
  }
}

// Дерево совпадает с пререндером (app/seo/prerender.tsx) — один RouterProvider
// без соседей, иначе useId на клиенте даёт другие id, чем в HTML
const AppRouter: FC = () => {
  useRouteMetadata();
  // Эффект корня срабатывает после гидратации оболочки, но ленивая граница страницы может ещё
  // ждать свой чанк — replayEarlyClick ждёт её гидратации перед повтором нажатия
  useEffect(replayEarlyClick, []);
  return <RouterProvider router={router} />;
};

export const App: FC = () => (
  <ErrorBoundary>
    <AppRouter />
  </ErrorBoundary>
);
